module.exports = __webpack_public_path__ + "images/data_10.png";